/**
 * The staff-management route tree — one screen, no nested detail route: an account is four fields
 * managed in place (`StaffPage.tsx`), the same flat shape as the YubiKeys pool.
 */
import type { ReactElement } from 'react';
import { Route, Routes } from 'react-router-dom';

import { StaffPage } from './StaffPage.tsx';

export { staffRoutePath } from './paths.ts';

export const StaffRouteTree = (): ReactElement => (
  <Routes>
    <Route path="/" element={<StaffPage />} />
  </Routes>
);
